/**
 * Do not edit directly
 * Generated on Fri, 06 Sep 2024 12:06:14 GMT
 */


export const TypographyFontFamilyOpenSans = "'Open Sans', sans-serif";
export const TypographyLineHeight9xl = "1";
export const TypographyLineHeight8xl = "1";
export const TypographyLineHeight7xl = "1";
export const TypographyLineHeight6xl = "1";
export const TypographyFontLegacy = "'Roboto', 'Helvetica', 'Arial', sans-serif"; // Legacy Lens font, will be replaced with Open Sans
export const TypographyFontPrimary = "'Open Sans', sans-serif";
export const TransitionEasingInOut = "ease-in-out";
export const TransitionEasingDefault = "ease";
export const TransitionDurationSlow = ".75s";
export const TransitionDurationDefault = ".25s";
export const SpacingH4BasekickBaseline = "0em";
export const SpacingH4BasekickCap = "0em";
export const SpacingH4BlockEnd = "0rem";
export const SpacingH3BasekickBaseline = "0em";
export const SpacingH3BasekickCap = "0em";
export const SpacingH3BlockEnd = "0rem";
export const SpacingH2CapsBasekickBaseline = "-0.11148em";
export const SpacingH2CapsBasekickCap = "-0.13628em";
export const SpacingH2CapsBlockEnd = "0.27873rem";
export const SpacingH2BasekickBaseline = "-0.08484em";
export const SpacingH2BasekickCap = "-0.10964em";
export const SpacingH2BlockEnd = "0.2431rem";
export const SpacingH1BasekickBaseline = "-0.6121em";
export const SpacingH1BasekickCap = "-0.6741em";
export const SpacingH1BlockEnd = "1.9293rem";
export const Spacing95 = "2.375rem"; // Spacing multiplier 9.5
export const Spacing85 = "2.125rem"; // Spacing multiplier 8.5
export const Spacing75 = "1.875rem"; // Spacing multiplier 7.5
export const Spacing65 = "1.625rem"; // Spacing multiplier 6.5
export const Spacing55 = "1.375rem"; // Spacing multiplier 5.5
export const Spacing45 = "1.125rem"; // Spacing multiplier 4.5
export const Spacing35 = "0.875rem"; // Spacing multiplier 3.5
export const Spacing275 = "0.6875rem"; // Spacing multiplier 2.75
export const Spacing25 = "0.625rem"; // Spacing multiplier 2.5
export const Spacing225 = "0.5625rem"; // Spacing multiplier 2.25
export const Spacing175 = "0.4375rem"; // Spacing multiplier 1.75
export const Spacing15 = "0.375rem"; // Spacing multiplier 1.5
export const Spacing125 = "0.3125rem"; // Spacing multiplier 1.25
export const Spacing075 = "0.1875rem"; // Spacing multiplier 0.75
export const Spacing05 = "0.125rem"; // Spacing multiplier 0.5
export const Spacing025 = "0.0625rem"; // Spacing multiplier 0.25
export const Spacing96 = "24rem"; // Spacing multiplier 96
export const Spacing80 = "20rem"; // Spacing multiplier 80
export const Spacing72 = "18rem"; // Spacing multiplier 72
export const Spacing64 = "16rem"; // Spacing multiplier 64
export const Spacing60 = "15rem"; // Spacing multiplier 60
export const Spacing56 = "14rem"; // Spacing multiplier 56
export const Spacing52 = "13rem"; // Spacing multiplier 52
export const Spacing48 = "12rem"; // Spacing multiplier 48
export const Spacing44 = "11rem"; // Spacing multiplier 44
export const Spacing40 = "10rem"; // Spacing multiplier 40
export const Spacing36 = "9rem"; // Spacing multiplier 36
export const Spacing32 = "8rem"; // Spacing multiplier 32
export const Spacing28 = "7rem"; // Spacing multiplier 28
export const Spacing24 = "6rem"; // Spacing multiplier 24
export const Spacing20 = "5rem"; // Spacing multiplier 20
export const Spacing18 = "4.5rem"; // Spacing multiplier 18
export const Spacing16 = "4rem"; // Spacing multiplier 16
export const Spacing14 = "3.5rem"; // Spacing multiplier 14
export const Spacing12 = "3rem"; // Spacing multiplier 12
export const Spacing10 = "2.5rem"; // Spacing multiplier 10
export const Spacing9 = "2.25rem"; // Spacing multiplier 9
export const Spacing8 = "2rem"; // Spacing multiplier 8
export const Spacing7 = "1.75rem"; // Spacing multiplier 7
export const Spacing6 = "1.5rem"; // Spacing multiplier 6
export const Spacing5 = "1.25rem"; // Spacing multiplier 5
export const Spacing4 = "1rem"; // Spacing multiplier 4
export const Spacing3 = "0.75rem"; // Spacing multiplier 3
export const Spacing2 = "0.5rem"; // Spacing multiplier 2
export const Spacing1 = "0.25rem"; // Spacing multiplier 1
export const ScreenWidthMaxXl = "1535px";
export const ScreenWidthMaxLg = "1279px";
export const ScreenWidthMaxMd = "1023px";
export const ScreenWidthMaxSm = "767px";
export const ScreenWidthMaxXs = "639px";
export const ScreenWidthMin2xl = "1536px";
export const ScreenWidthMinXl = "1280px";
export const ScreenWidthMinLg = "1024px";
export const ScreenWidthMinMd = "768px";
export const ScreenWidthMinSm = "640px";
export const OpacityDisabled = "0.5";
export const TypographyFontHeader = "'Open Sans', sans-serif";
export const TypographyFontMain = "'Open Sans', sans-serif";
export const TypographyHeadingLineHeightH5 = "1.5rem";
export const TypographyHeadingSizeH5 = "0.625rem";
export const TypographyLineHeight5xl = "3rem";
export const TypographyLineHeight4xl = "3rem";
export const TypographyLineHeight3xl = "3rem";
export const TypographyLineHeight2xl = "1.5rem";
export const TypographyLineHeightXl = "1.5rem";
export const TypographyLineHeightLg = "1.5rem";
export const TypographyLineHeightBase = "1.5rem";
export const TypographyLineHeightSm = "1.5rem";
export const TypographyLineHeightXs = "1.5rem";
export const TypographyLineHeightXxs = "1.5rem";
export const TypographySize9xl = "4.5rem";
export const TypographySize8xl = "4rem";
export const TypographySize7xl = "3rem";
export const TypographySize6xl = "2.5rem";
export const TypographySize5xl = "2.25rem";
export const TypographySize4xl = "2rem";
export const TypographySize3xl = "1.5rem";
export const TypographySize2xl = "1.25rem";
export const TypographySizeXl = "1.125rem";
export const TypographySizeLg = "1rem";
export const TypographySizeBase = "0.875rem";
export const TypographySizeSm = "0.75rem";
export const TypographySizeXs = "0.6875rem";
export const TypographySizeXxs = "0.5rem";
export const SpacingPBlockEnd = "1rem";
export const Spacing3xl = "2.5rem";
export const Spacing2xl = "2rem";
export const SpacingXl = "1.5rem";
export const SpacingLg = "1rem";
export const SpacingMd = "0.75rem";
export const SpacingSm = "0.5rem";
export const SpacingXs = "0.25rem";
export const SpacingXxs = "0.125rem";
export const Radius3xl = "1.5rem";
export const Radius2xl = "1rem";
export const RadiusXl = "0.75rem";
export const RadiusLg = "0.5rem";
export const RadiusMd = "0.375rem";
export const RadiusDefault = "0.25rem";
export const RadiusSm = "0.125rem";
export const RadiusXs = "0.0625rem";
export const TypographyHeadingLineHeightH4 = "1.5rem";
export const TypographyHeadingLineHeightH3 = "1.5rem";
export const TypographyHeadingLineHeightH2Caps = "1.5rem";
export const TypographyHeadingLineHeightH2 = "1.5rem";
export const TypographyHeadingLineHeightH1 = "3rem";
export const TypographyHeadingSizeH4 = "0.875rem";
export const TypographyHeadingSizeH3 = "0.875rem";
export const TypographyHeadingSizeH2Caps = "1.125rem";
export const TypographyHeadingSizeH2 = "1.125rem";
export const TypographyHeadingSizeH1 = "1.25rem";
